import { type FunctionComponent } from 'react';
import { useRestrictedInventory } from '../../../hooks/restricted-inventory/restricted-inventory.hooks';

export type ProductStockProps = {
	count: number;
	className?: string;
	isMadeToOrder: boolean;
	isRegionallyOutOfStock?: boolean;
	brand?: string;
};

const NORMAL_TEXT = 'theme-grey-darker lh-solid';
const ERROR_TEXT = 'lh-solid theme-error';

export const ProductStock: FunctionComponent<ProductStockProps> = ({
	count,
	isMadeToOrder,
	className = '',
	isRegionallyOutOfStock = false,
	brand
}) => {
	const stockMessage: { message?: string; theme?: string } = {};
	const { isRestricted, maxQuantity } = useRestrictedInventory(brand || '');
	const restrictedCount = isRestricted && count > maxQuantity ? maxQuantity : count;

	if (isRegionallyOutOfStock) {
		// Product is regionally restricted and should display out of stock
		stockMessage.message = 'Out Of Stock';
		stockMessage.theme = ERROR_TEXT;
	} else if (isMadeToOrder) {
		// Product doesn't display a stock quantity - its made on demand
		stockMessage.message = 'Made To Order';
		stockMessage.theme = NORMAL_TEXT;
	} else if (count > 0) {
		// Product is in stock, show quantity
		stockMessage.message = `${restrictedCount} In Stock`;
		stockMessage.theme = NORMAL_TEXT;
	} else {
		// Product is out of stock
		stockMessage.message = 'Special Order';
		stockMessage.theme = ERROR_TEXT;
	}

	return (
		<div className={`pl1 ${className}`} data-testid={'product-stock-status'}>
			<span className={stockMessage.theme}>{stockMessage.message}</span>
		</div>
	);
};
